import TrainingDetail from "./TrainingDetail";
import styled from "styled-components";

const GameAreaContainer = styled.div`
  display: flex;
  width: 100%;
  position: relative;
  min-height: 360px;
`;

const GameScreen = styled.div`
  width: 100%;
  max-width: 505px;
`;

export default ({ children = [], game = {} , showDetail = true}: any) => {
  return (
    <GameAreaContainer>
      <GameScreen>{children}</GameScreen>
      {showDetail && (
        <TrainingDetail>
          <span>{game ? game.training : <></>}</span>
        </TrainingDetail>
      )}
    </GameAreaContainer>
  );
};
